import React from 'react';
import { Delta, DeltaDirection } from '@usepepper/sprout-kit-ui';
import { PriceEditDisplayInfoTrend } from '@/types';

interface OrderEntryTableTrendCellProps {
  displayValue: string | null;
  trend?: PriceEditDisplayInfoTrend | null;
}

const DELTA_DIRECTION_BY_TREND: Record<
  PriceEditDisplayInfoTrend,
  DeltaDirection
> = {
  [PriceEditDisplayInfoTrend.Up]: 'up',
  [PriceEditDisplayInfoTrend.Down]: 'down',
};

export const OrderEntryTableTrendCell: React.FC<
  OrderEntryTableTrendCellProps
> = ({ displayValue, trend }) => (
  <Delta
    direction={trend ? DELTA_DIRECTION_BY_TREND[trend] : 'flat'}
    size="$md"
    value={displayValue ?? ''}
  />
);
